module.exports = __webpack_public_path__ + "static/yougogirls-90a4494d03371cf9377a982d85fd4d1b.jpg";